import { render, staticRenderFns } from "./ReferralChatModal.vue?vue&type=template&id=17da5606"
import script from "./ReferralChatModal.vue?vue&type=script&lang=js"
export * from "./ReferralChatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports